export const GET_ADDRESSES_SUCCESS = 'GET_ADDRESSES_SUCCESS';
export const SET_ADDRESS_DATA_LOADING = 'SET_ADDRESS_DATA_LOADING';
export const SET_INVALID_ADDRESS_FIELDS = 'SET_INVALID_ADDRESS_FIELDS';
export const SET_SUGGESTED_ADDRESSES = 'SET_SUGGESTED_ADDRESSES';
export const CLEAR_INVALID_ADDRESS_FIELDS_AND_ERRORS = 'CLEAR_ADDRESS_INVALID_FIELDS_AND_ERRORS';
export const CLEAR_ADDRESS_FORM_ITEM = 'CLEAR_ADDRESS_FORM_ITEM';
export const ON_TOGGLE_IS_ALSO_BILLING = 'ON_TOGGLE_IS_ALSO_BILLING';
export const ON_TOGGLE_IS_DEFAULT_SHIPPING_ADDRESS = 'ON_TOGGLE_IS_DEFAULT_SHIPPING_ADDRESS';
export const SET_ADDRESS_FORM_ITEM = 'SET_ADDRESS_FORM_ITEM';
export const SET_TEMP_ADDRESS_FAILURE_MSG = 'SET_TEMP_ADDRESS_FAILURE_MSG';
export const SET_TEMP_ADDRESS_SUCCESS_MSG = 'SET_TEMP_ADDRESS_SUCCESS_MSG';
export const SET_EDIT_OF_INACTIVE_ADDRESS_ERROR = 'SET_EDIT_OF_INACTIVE_ADDRESS_ERROR';
